import { SourcingEventStatus, type OrgDto, type SourcingEventDto } from "../../autogen/bff-api";
import { isBidDeadlinePassed } from "./supplierRows";

export type BidViewer = Pick<OrgDto, "canSeeDeliveredBidsBeforeDeadline">;

export const hasEarlyBidAccess = (event: SourcingEventDto, viewer: BidViewer): boolean =>
  event.eventContext.type === "Private" && viewer.canSeeDeliveredBidsBeforeDeadline;

export const isBidContentUnsealed = (event: SourcingEventDto, viewer: BidViewer): boolean =>
  isBidDeadlinePassed(event) || hasEarlyBidAccess(event, viewer);

export const isScoringOpen = (event: SourcingEventDto): boolean =>
  event.status === SourcingEventStatus.Evaluation;

export const isMinimumRequirementReviewOpen = (event: SourcingEventDto): boolean =>
  event.eventContext.type !== "Private" || isScoringOpen(event);
